// extracted by mini-css-extract-plugin
module.exports = {"typeCol":"SocialLeavesTable_typeCol__36wuR","tooltip__popper":"SocialLeavesTable_tooltip__popper__39p8l","tooltip__root":"SocialLeavesTable_tooltip__root__2E8Pg"};